import React from 'react';
import Donation from '../../api/donation';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const DonationListSection = () => {
    const { t } = useTranslation();
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-12">
                    <div className="sectionTitle aboutSupport__heading text-center">
                        <h2 className="sectionTitle__big">{t("support_title")}</h2>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center">
                {Donation.map((donation, index) => (
                    <div className="col-lg-4 col-md-6 mb-4 d-flex" key={index}>
                        <div className="featureBlock aboutSupport__card">
                            <div className="featureBlock__wrap">
                                <div className="featureBlock__content">
                                    <h3 className="featureBlock__heading">
                                        <Link onClick={ClickHandler} to="/donation-listing" className="featureBlock__heading__link">
                                            {t(`donation_title_${index}`)}
                                        </Link>
                                    </h3>
                                    <p className="featureBlock__text">
                                        {t(`donation_desc_${index}`)}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default DonationListSection;
